import astroEventsChange from './actions/astroEventsChange';
import astroEventsCreate from './actions/astroEventsCreate';
import astroEventsDetail from './actions/astroEventsDetail';
import astroEventsList from './actions/astroEventsList';
import getAstroEvents from './getters/getAstroEvents';
import astroEventsUpload from './mutations/astroEventsUpload';

const actions = {
    astroEventsChange,
    astroEventsCreate,
    astroEventsDetail,
    astroEventsList
};

const mutations = {
    astroEventsUpload
};

const getters = {
    getAstroEvents
};

export default { actions, mutations, getters };
